var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-modal', {
    attrs: {
      "id": "modal-payment-for-distribution",
      "size": "md",
      "centered": "",
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.resetFormData,
      "shown": _vm.openForm
    },
    scopedSlots: _vm._u([{
      key: "modal-header",
      fn: function () {
        return [_c('h4', {
          staticClass: "mb-0 text-primary"
        }, [_vm._v(" " + _vm._s(_vm.isViewOnly && _vm.dataPayment ? _vm.$t("ar_client_invoice_details") : !_vm.isViewOnly && _vm.dataPayment ? _vm.$t("ar_client_edit_payment") : _vm.$t("ar_client_add_pay")) + " ")]), _c('div', {
          staticClass: "d-flex align-items-center"
        }, [_vm.dataPayment && _vm.isValidPermission(_vm.apiCode) ? _c('ez-icon', {
          staticClass: "mr-1",
          class: {
            'cursor-pointer': _vm.isViewOnly
          },
          attrs: {
            "icon": "ezAr-icon-edit",
            "size": "24",
            "color": _vm.isViewOnly ? '#ea5455' : '#ccc'
          },
          on: {
            "click": function ($event) {
              _vm.isViewOnly = false;
            }
          }
        }) : _vm._e(), _c('ez-icon', {
          staticClass: "cursor-pointer",
          attrs: {
            "icon": "ezAr-icon-x",
            "size": "24",
            "color": "#114A9F"
          },
          on: {
            "click": _vm.hideModal
          }
        })], 1)];
      },
      proxy: true
    }])
  }, [_c('b-card-body', [_c('b-overlay', {
    attrs: {
      "show": _vm.isLoading,
      "opacity": 0.3,
      "rounded": "sm"
    }
  }, [_c('validation-observer', {
    ref: "formRef"
  }, [_c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_payment_type")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.paymentTypeOptions,
      "placeholder": _vm.$t('golf_payment_payment_type'),
      "clearable": false,
      "label": "title",
      "reduce": function (option) {
        return option.value;
      }
    },
    model: {
      value: _vm.form.PaymentDetailType,
      callback: function ($$v) {
        _vm.$set(_vm.form, "PaymentDetailType", $$v);
      },
      expression: "form.PaymentDetailType"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires",
    on: {
      "mouseleave": function ($event) {
        return _vm.handlePaymentType('hide');
      }
    }
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_payment_method")))]), _c('WidgetSelect', {
    attrs: {
      "defaultValue": function (options) {
        return options.find(function (opt) {
          return opt.ParentKeyword === 'TMT';
        });
      },
      "dataSource": _vm.listPaymentType,
      "customOptions": function (options) {
        return options.map(function (option) {
          return Object.assign({}, option, {
            CodeName: ((option.ParentKeyword) + " - " + (option.NameVi))
          });
        });
      },
      "label": "CodeName",
      "placeholder": "golf_payment_payment_method",
      "disabled": _vm.isViewOnly
    },
    on: {
      "change": _vm.handleChoicePayment
    },
    model: {
      value: _vm.form.PaymentMethodId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "PaymentMethodId", $$v);
      },
      expression: "form.PaymentMethodId"
    }
  })], 1)])]), _vm.showFormInputPaymentMethod.VNPAY || _vm.showFormInputPaymentMethod.BANK ? _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('FormItem', {
    attrs: {
      "type": "string",
      "disabled": _vm.isViewOnly,
      "rules": {
        required: true
      },
      "label": "ar_client_transaction_code",
      "placeholder": "ar_client_transaction_code"
    },
    model: {
      value: _vm.form.TransactionCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "TransactionCode", $$v);
      },
      expression: "form.TransactionCode"
    }
  })], 1), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_currency_code")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.LS_Currency,
      "placeholder": _vm.$t('golf_payment_currency_code'),
      "clearable": false,
      "label": "Format",
      "reduce": function (option) {
        return option.Id;
      }
    },
    on: {
      "option:selected": _vm.onSelectCurrency
    },
    model: {
      value: _vm.form.CurrencyCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CurrencyCode", $$v);
      },
      expression: "form.CurrencyCode"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_amount")))])])]), _c('cleave', {
    staticClass: "form-control text-right",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.inputMaskByCurrency(),
      "placeholder": "1,000,000"
    },
    model: {
      value: _vm.form.Amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Amount", $$v);
      },
      expression: "form.Amount"
    }
  })], 1)])]) : _vm.showFormInputPaymentMethod.CARD ? _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_card_number")))]), _c('b-form-group', [_c('cleave', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": false,
      "options": _vm.maskCreditCard,
      "maxlength": 50
    },
    model: {
      value: _vm.form.CardNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CardNumber", $$v);
      },
      expression: "form.CardNumber"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_currency_code")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.LS_Currency,
      "placeholder": _vm.$t('golf_payment_currency_code'),
      "clearable": false,
      "label": "Format",
      "reduce": function (option) {
        return option.Id;
      }
    },
    on: {
      "option:selected": _vm.onSelectCurrency
    },
    model: {
      value: _vm.form.CurrencyCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CurrencyCode", $$v);
      },
      expression: "form.CurrencyCode"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_amount")))])])]), _c('cleave', {
    staticClass: "form-control text-right",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.inputMaskByCurrency(),
      "placeholder": "1,000,000"
    },
    model: {
      value: _vm.form.Amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Amount", $$v);
      },
      expression: "form.Amount"
    }
  })], 1)])]) : _vm.showFormInputPaymentMethod.CREDIT ? _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("ar_client_card_owner")))]), _c('b-form-group', {
    staticClass: "validate-voucher"
  }, [_c('b-form-input', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "placeholder": _vm.$t('ar_client_card_owner')
    },
    model: {
      value: _vm.form.AccountHolder,
      callback: function ($$v) {
        _vm.$set(_vm.form, "AccountHolder", $$v);
      },
      expression: "form.AccountHolder"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-8"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_card_number")))]), _c('b-form-group', [_c('cleave', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.maskCreditCard,
      "maxlength": 50
    },
    model: {
      value: _vm.form.CardNumber,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CardNumber", $$v);
      },
      expression: "form.CardNumber"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_expiration_date")))]), _c('b-form-group', [_c('cleave', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": false,
      "options": _vm.maskExpirationDate,
      "placeholder": "MM/YY"
    },
    model: {
      value: _vm.form.ExpirationDate,
      callback: function ($$v) {
        _vm.$set(_vm.form, "ExpirationDate", $$v);
      },
      expression: "form.ExpirationDate"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_currency_code")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.LS_Currency,
      "placeholder": _vm.$t('golf_payment_currency_code'),
      "clearable": false,
      "label": "Format",
      "reduce": function (option) {
        return option.Id;
      }
    },
    on: {
      "option:selected": _vm.onSelectCurrency
    },
    model: {
      value: _vm.form.CurrencyCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CurrencyCode", $$v);
      },
      expression: "form.CurrencyCode"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_amount")))])])]), _c('cleave', {
    staticClass: "form-control text-right",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.inputMaskByCurrency(),
      "placeholder": "1,000,000"
    },
    model: {
      value: _vm.form.Amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Amount", $$v);
      },
      expression: "form.Amount"
    }
  })], 1)])]) : _vm.PaymentMethodByVoucherInTransactionCode === _vm.TransactionCode ? _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_currency_code")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.LS_Currency,
      "placeholder": _vm.$t('golf_payment_currency_code'),
      "clearable": false,
      "label": "Format",
      "reduce": function (option) {
        return option.Id;
      }
    },
    on: {
      "option:selected": _vm.onSelectCurrency
    },
    model: {
      value: _vm.form.CurrencyCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CurrencyCode", $$v);
      },
      expression: "form.CurrencyCode"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_amount")))])])]), _c('cleave', {
    staticClass: "form-control text-right",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.inputMaskByCurrency(),
      "placeholder": "1,000,000"
    },
    model: {
      value: _vm.form.Amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Amount", $$v);
      },
      expression: "form.Amount"
    }
  })], 1)]), _vm.form.VoucherCode && _vm.voucherDetail ? _c('div', {
    staticClass: "col-lg-12"
  }, [_c('p', {
    staticClass: "text-danger mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("golf_voucher_name")) + ": " + _vm._s(_vm.voucherDetail.Voucher.VoucherName) + " ")]), _c('p', {
    staticClass: "text-danger mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("golf_voucher_amount")) + ": " + _vm._s(_vm.formatPrice(_vm.voucherDetail.TotalAmount)) + " ")]), _c('p', {
    staticClass: "text-danger mb-0"
  }, [_vm._v(" " + _vm._s(_vm.$t("golf_voucher_time_apply")) + ": " + _vm._s(_vm.convertUTC(_vm.voucherDetail.Voucher.OpenDate, "DD/MM/YYYY")) + " - " + _vm._s(_vm.convertUTC(_vm.voucherDetail.Voucher.ExpirationDate, "DD/MM/YYYY")) + " ")])]) : _vm._e()]) : _vm.showFormInputPaymentMethod.OTHER && _vm.PaymentMethodByEvoucherInTransactionCode != _vm.TransactionCode && _vm.PaymentMethodByVoucherInTransactionCode != _vm.TransactionCode ? _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_currency_code")))]), _c('b-form-group', [_c('v-select', {
    attrs: {
      "disabled": _vm.isViewOnly,
      "options": _vm.LS_Currency,
      "placeholder": _vm.$t('golf_payment_currency_code'),
      "clearable": false,
      "label": "Format",
      "reduce": function (option) {
        return option.Id;
      }
    },
    on: {
      "option:selected": _vm.onSelectCurrency
    },
    model: {
      value: _vm.form.CurrencyCode,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CurrencyCode", $$v);
      },
      expression: "form.CurrencyCode"
    }
  })], 1)], 1)]), _c('div', {
    staticClass: "col-lg-6"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('div', {
    staticClass: "d-flex justify-content-between"
  }, [_c('div', [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_amount")))])]), _c('div', [_vm.showMoneyExchange ? _c('div', {
    staticClass: "text-right money-exchange"
  }, [_vm._v(" = " + _vm._s(_vm.totalAmountPaymentInputExchangeDisplay) + " ")]) : _vm._e()])]), _c('cleave', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isViewOnly,
      "raw": true,
      "options": _vm.inputMaskByCurrency(),
      "placeholder": "1,000,000"
    },
    model: {
      value: _vm.form.Amount,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Amount", $$v);
      },
      expression: "form.Amount"
    }
  })], 1)])]) : _vm._e(), _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col-lg-12"
  }, [_c('div', {
    staticClass: "form-group label-requires"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v(_vm._s(_vm.$t("golf_payment_cashier")))]), _c('b-form-group', [_c('WidgetSelect', {
    attrs: {
      "customOptions": function (options) {
        return options.map(function (option) {
          return Object.assign({}, option, {
            CodeName: ((option.TaUserCode) + " - " + (option.Fullname))
          });
        });
      },
      "placeholder": "golf_payment_cashier",
      "dataSourceParams": {
        IsCheckPermission: false
      },
      "dataSource": _vm.arClient.api_AP_RTU01,
      "label": "CodeName",
      "disabled": _vm.isViewOnly
    },
    model: {
      value: _vm.form.CashierId,
      callback: function ($$v) {
        _vm.$set(_vm.form, "CashierId", $$v);
      },
      expression: "form.CashierId"
    }
  })], 1)], 1)])]), _c('div', {
    staticClass: "form-row form-group"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("ar_client_note")))]), _c('b-form-textarea', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.isViewOnly,
      "placeholder": _vm.$t('golf_payment_note'),
      "rows": "2",
      "wrap": "soft",
      "maxlength": 250
    },
    model: {
      value: _vm.form.Note,
      callback: function ($$v) {
        _vm.$set(_vm.form, "Note", $$v);
      },
      expression: "form.Note"
    }
  })], 1)]), _c('div', {
    staticClass: "form-row mt-2 form-group text-right"
  }, [_c('div', {
    staticClass: "col"
  }, [!_vm.isViewOnly ? _c('b-button', {
    staticStyle: {
      "white-space": "nowrap"
    },
    attrs: {
      "variant": "primary",
      "disabled": !_vm.isSubmit
    },
    on: {
      "click": _vm.createPaymentDetail_IPM04
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_save")) + " ")]) : _vm._e()], 1)])])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }